import React from 'react';
import { Box, Container, Typography, Grid, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

const ALTERNATIVES = [
  'Avaliar possibilidades disponíveis.',
  'Comparar opções.',
  'Entender melhor cobertura e custo-benefício.',
];

const EconomiaSection: React.FC = () => {
  return (
    <Box component="section" sx={{ py: { xs: 8, md: 12 }, bgcolor: 'background.paper' }}>
      <Container maxWidth="lg">
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          sx={{ textAlign: 'center', maxWidth: 680, mx: 'auto', mb: 7 }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '0.8rem',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: 'secondary.dark',
              mb: 1.5,
            }}
          >
            Vale a pena avaliar
          </Typography>
          <Typography variant="h2" sx={{ fontSize: { xs: '1.75rem', md: '2.25rem' } }}>
            Antes de aceitar o próximo reajuste, conheça suas possibilidades.
          </Typography>
        </Box>

        <Grid container spacing={3} sx={{ maxWidth: 880, mx: 'auto' }}>
          <Grid item xs={12} sm={6}>
            <Box
              component={motion.div}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5 }}
              sx={{
                height: '100%',
                p: 4,
                borderRadius: '18px',
                bgcolor: 'background.default',
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: 'text.secondary', mb: 2.5 }}>
                Situação comum
              </Typography>
              <Stack direction="row" spacing={1.5} alignItems="flex-start">
                <CancelRoundedIcon sx={{ fontSize: 20, color: '#9aa5a4', mt: 0.2 }} />
                <Typography sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                  Aceitar reajustes sem avaliar alternativas.
                </Typography>
              </Stack>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box
              component={motion.div}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              sx={{
                height: '100%',
                p: 4,
                borderRadius: '18px',
                bgcolor: 'rgba(14, 75, 79, 0.04)',
                border: '1.5px solid',
                borderColor: 'primary.main',
              }}
            >
              <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: 'primary.main', mb: 2.5 }}>
                Com a MedPrime
              </Typography>
              <Stack spacing={1.5}>
                {ALTERNATIVES.map((item) => (
                  <Stack key={item} direction="row" spacing={1.5} alignItems="flex-start">
                    <CheckCircleRoundedIcon sx={{ fontSize: 20, color: 'primary.main', mt: 0.2 }} />
                    <Typography sx={{ color: 'text.primary', fontWeight: 500, lineHeight: 1.6 }}>
                      {item}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Box>
          </Grid>
        </Grid>

        <Typography
          sx={{
            textAlign: 'center',
            fontSize: '0.85rem',
            color: 'text.secondary',
            mt: 4,
            maxWidth: 560,
            mx: 'auto',
          }}
        >
          Trabalhamos com possibilidade de economia e melhor custo-benefício — sem prometer
          resultados financeiros garantidos.
        </Typography>
      </Container>
    </Box>
  );
};

export default EconomiaSection;
